module.exports = __webpack_public_path__ + "static/3-95c6d371464f0a8a20c039c03e0fbd5e.jpeg";